// Mirror of backend `normalize_category` in /app/backend/helpers.py.
// Collapses known category aliases onto a single canonical name so the
// Production view groups duplicates ("Chilled" vs "Chilled/Hybrid") correctly
// even when the database still holds legacy strings.
const CATEGORY_ALIASES = {
  "chilled": "Chilled/Hybrid",
  "chilled/hybrid": "Chilled/Hybrid",
  "heat to eat": "Heat to Eat",
  "baked goods": "Baked Goods",
  "weekly specials": "Weekly Specials",
  "snack pots": "Snack Pots",
  "add-on": "Add-on",
  "add on": "Add-on",
};

export const normalizeCategory = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  return CATEGORY_ALIASES[trimmed.toLowerCase()] || trimmed;
};
